import { render, staticRenderFns } from "./list-prize-result.vue?vue&type=template&id=8f1aa8cc"
import script from "./list-prize-result.vue?vue&type=script&lang=js"
export * from "./list-prize-result.vue?vue&type=script&lang=js"
import style0 from "./list-prize-result.vue?vue&type=style&index=0&id=8f1aa8cc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports